/*
 * Direct crs-api / TenantHub auth endpoints (no BFF). Paths are relative to
 * VITE_API_BASE_URL (which carries no `/api` suffix).
 */
export const authEndpoints = {
  discover: () => '/api/v1/Auth/discover',
  authenticate: () => '/api/v1/Auth/authenticate',
  refresh: () => '/api/v1/Auth/refresh',
  logout: () => '/api/v1/Auth/logout',
  /** Anonymous; `?roles=a,b` appended by the caller. */
  rolePermissionsByRoles: () => '/api/v1/RolePermissions/by-roles',
};

export const fileEndpoints = {
  /** Blob download with auth headers; `path` is adapter-relative. */
  download: (path: string) => `/api/v1/Files/download?path=${encodeURIComponent(path)}`,
};
